/* eslint eqeqeq: "off" */
import React, { useContext, useEffect, useState, useRef } from "react";
import Context from "./Context";
// imagens.
import power from '../images/power.png';
// router.
import { useHistory } from "react-router-dom";
import SimplePeer from 'simple-peer';

// websocket (socket.io)
import { io } from 'socket.io-client';

// tela para o paciente acessar a teleconsulta.
function TeleconsultaPaciente() {
  // context.
  const {
    pagina,
    setpagina,
    setsocket_teleconsulta,
    socket_teleconsulta,
  } = useContext(Context);

  // history (router).
  let history = useHistory();
  useEffect(() => {
    if (pagina == 'teleconsulta-paciente') {
      // setsocket_teleconsulta(io.connect('http://localhost:4000'));
      setsocket_teleconsulta(io.connect('https://pulsar-pep-teleconsultas-server.up.railway.app'));
    }
    // eslint-disable-next-line
  }, [pagina]);

  const [objstream, setobjstream] = useState(null);

  let peer_paciente = null;
  const peer_paciente_Ref = useRef(null);

  const sendStream = () => {
    // iniciando o stream de vídeo.
    let constraints =
    {
      video: {
        facingMode: 'user'
      },
      audio: true
    }
    navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
      localStorage.setItem('codigo', document.getElementById('inputCodigo').value);
      setobjstream(stream);
      setTimeout(() => {
        document.getElementById('input').style.display = 'none';
        document.getElementById('video').style.display = 'flex';
        // projetando a câmera do paciente na tela do paciente.
        let video = document.getElementById('video-teleconsulta-paciente');
        video.srcObject = stream;

        // criando o peer_paciente.
        peer_paciente = new SimplePeer({
          initiator: false,
          trickle: false,
          stream: stream,
        });

        // criando useRef para guardar o objeto peer.
        peer_paciente_Ref.current = peer_paciente;

        // ## TROCA DE SINAIS DOS PARES PARA ESTABELECER CONEXÃO ## //
        // enviando para o server o código que permite a conexão correta entre médico e paciente (o código é a id_atendimento).
        socket_teleconsulta.emit('download dados peer-medico', localStorage.getItem('codigo'));

        // recebendo do server o sinal do médico.
        socket_teleconsulta.on('dados peer-medico', function (data) {
          console.log('RECEBENDO DO SERVER O SINAL DO MÉDICO.');
          peer_paciente.signal(data);
        });

        // enviando sinal do paciente para o server.
        peer_paciente.on('signal', function (data) {
          console.log(data.type);
          console.log('ENVIANDO SINAL DO PACIENTE PARA O SERVER.');
          let obj = {
            tipo: 'paciente',
            codigo: localStorage.getItem('codigo'),
            data: data,
            id: socket_teleconsulta.id,
          }
          socket_teleconsulta.emit('upload dados peer-paciente', obj);
        });

        // projetando a câmera do médico na tela do médico.
        peer_paciente.on('stream', function (stream) {
          var video = document.getElementById('video-teleconsulta-medico');
          video.srcObject = stream;
          video.play()
        });

      }, 2000);
    });
  }

  const encerrandoStream = () => {
    let stream = objstream;
    console.log(stream);
    stream.getTracks().forEach(function (track) {
      track.stop();
      console.log('ENCERRANDO STREAM');
    })
  }

  function Input() {
    return (
      <div id='input'
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignSelf: "center",
          justifyItems: 'center',
          alignItems: 'center',
        }}
      >
        <div className="text2">{'POR FAVOR, DIGITE O CÓDIGO RECEBIDO PELO WHATSAPP'}</div>
        <input
          autoComplete="off"
          placeholder="CÓDIGO"
          className="input"
          type="text"
          id="inputCodigo"
          onFocus={(e) => (e.target.placeholder = "")}
          onBlur={(e) => (e.target.placeholder = "CÓDIGO")}
          style={{
            marginTop: 10,
            marginBottom: 10,
            width: 200,
            height: 50,
          }}
        ></input>
        <div
          id="btn_entrar"
          className="button"
          style={{
            width: 200, minWidth: 200, alignSelf: 'center',
          }}
          onClick={() => {
            sendStream();
          }}
        >
          {'ENTRAR NA CONSULTA'}
        </div>
      </div>
    );
    // eslint-disable-next-line
  };

  function VideoStream() {
    return (
      <div id='video' style={{ display: 'none', flexDirection: 'column', justifyContent: 'center', position: 'relative' }}>
        <video id="video-teleconsulta-medico" autoplay='true' disablePictureInPicture='true' width='250px'
          style={{ objectFit: 'contain', borderRadius: 5, width: window.innerWidth - 20 }}>
        </video>
        <div style={{ display: 'flex', position: 'absolute', bottom: 5, right: 5 }}>
          <video id="video-teleconsulta-paciente" autoplay='true' disablePictureInPicture='true' width='50px'
            style={{ objectFit: 'contain', borderRadius: 5, width: 50 }}>
          </video>
        </div>
      </div>
    )
  }

  return (
    <div
      id="teleconsulta-paciente"
      className="main"
      style={{
        display: pagina == 'teleconsulta-paciente' ? "flex" : "none",
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <div className="text2" style={{ fontSize: 22 }}>{'BEM-VINDO(A) À TELECONSULTA'}</div>
      <Input></Input>
      <VideoStream></VideoStream>
      <div id="botão para sair da tela de teleconsulta"
        className="button-yellow"
        style={{
          maxHeight: 50, maxWidth: 50, alignSelf: 'center'
        }}
        onClick={() => {
          if (objstream) {
            socket_teleconsulta.emit('desconectar', localStorage.getItem('codigo'));
            socket_teleconsulta.disconnect(); // única função eficaz para desconexão do usuário a partir do cliente.
            encerrandoStream();
            peer_paciente_Ref.current.destroy();
            setpagina(0);
            history.push("/");
          } else {
            setpagina(0);
            history.push("/");
          }
        }}>
        <img
          alt=""
          src={power}
          style={{ width: 30, height: 30 }}
        ></img>
      </div>
    </div>

  );
}

export default TeleconsultaPaciente;